import React from 'react';
import { IconProps } from './types/Icon.type';

function SearchDelete16Icon(props: IconProps) {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="7.5" fill={props.fill ?? '#E2E2E2'} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.771 10.4746C9.96626 10.6699 10.2828 10.6699 10.4781 10.4746C10.6734 10.2793 10.6734 9.96277 10.4781 9.7675L8.70861 7.99801L10.4741 6.2325C10.6694 6.03724 10.6694 5.72065 10.4741 5.52539C10.2789 5.33013 9.96228 5.33013 9.76702 5.52539L8.00151 7.2909L6.23546 5.52486C6.0402 5.3296 5.72362 5.3296 5.52836 5.52486C5.3331 5.72013 5.3331 6.03671 5.52836 6.23197L7.2944 7.99801L5.52438 9.76803C5.32911 9.9633 5.32911 10.2799 5.52438 10.4751C5.71964 10.6704 6.03622 10.6704 6.23148 10.4751L8.00151 8.70512L9.771 10.4746Z"
        fill={props.stroke ?? '#666666'}
      />
    </svg>
  );
}

export default SearchDelete16Icon;
